import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RTSJobStatus, RTSJobType } from '@numeo/types-core'

export interface RTSJobProgress {
    current: number
    total: number
    message: string
}

export interface RTSActiveJob {
    jobId: string
    type: RTSJobType
    status: RTSJobStatus
    progress: RTSJobProgress
    result?: unknown
    error?: string
}

export interface RTSJobState {
    activeJob: RTSActiveJob | null
}

const initialState: RTSJobState = {
    activeJob: null,
}

const rtsJobSlice = createSlice({
    name: 'rtsJob',
    initialState,
    reducers: {
        setActiveJob(state, action: PayloadAction<RTSActiveJob>) {
            state.activeJob = action.payload
        },
        updateJobProgress(state, action: PayloadAction<{ status: RTSJobStatus; progress: RTSJobProgress; result?: unknown; error?: string }>) {
            if (state.activeJob) {
                state.activeJob.status = action.payload.status
                state.activeJob.progress = action.payload.progress
                if (action.payload.result !== undefined) state.activeJob.result = action.payload.result
                if (action.payload.error !== undefined) state.activeJob.error = action.payload.error
            }
        },
        clearJob(state) {
            state.activeJob = null
        },
    },
})

export const { setActiveJob, updateJobProgress, clearJob } = rtsJobSlice.actions
export default rtsJobSlice.reducer
